import React from "react";
import Slider from "react-slick";
import Moment from 'moment';

export default class ImageSlider extends React.Component {

  render() {
    const settings = {
      dots: false,
      infinite: false,
      fade: false,
      afterChange: function(i){
        $('.featured').each(function(fi){
          if(i === fi) {
            $('.bg').removeClass('purple').removeClass('green').addClass($(this).attr('data-color'));
          }
        })
      }
    };

    return (
      <Slider {...settings}>{
        this.props.projects.map((project, i) =>
          <div key={i} className="homepage_slider">
            <img src={project.image.homepage.url} alt={project.title} />
            <div className='featured' data-color={project.subtitle ? "purple" : "green"}>
              <div className='date'>{project.subtitle ? "UZORNI PROJEKTI" : "NOVOSTI"} | {Moment(project.news_date).format('DD. MM. YYYY.')}</div>
                <h1>
                  <a href={"/"+ (project.subtitle ? "projekti" : "aktualnosti") +"/" + project.slug}>{project.title}</a>
                </h1>
                <p>
                {project.lead}
                </p>
            </div>
          </div>
        )}
      </Slider>
    );
  }
}



// WEBPACK FOOTER //
// app/frontend/components/Slider.jsx